import { axiosInstance } from '../axiosInstance';

export const bulkAddFavoritesApi = async (
  token: string | null,
  data: { items: { id: string; type: 'product' | 'part' | 'accessory' }[] },
): Promise<any> => {
  const headers: { Authorization?: string } = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await axiosInstance.post(`/view/favorites/bulk-add/`, data, {
    headers,
  });

  return response.data;
};
